import React from "react";
import { withTranslation } from "react-i18next";
import "./Footer.sass";
import BluHolding from "./../Header/bluholding.webp";
import Mail from "./mail.webp";
import Phone from "./phone.webp";
import Klaster from "./bki.webp";
import Iot from "./iot.png";
import { Linkedin, Facebook } from "lucide-react";

const isCorporateInfoSection = () =>
  window.location.hostname.includes(process.env.REACT_APP_SUBDOMAIN);

class Footer extends React.Component {
  #mainPageCallback;
  #scrollContactSection;

  constructor(props) {
    super(props);
    this.#mainPageCallback = props.mainPageCallback;
    this.#scrollContactSection = props.scrollContactSection;
  }

  render() {
    const { t } = this.props;
    const showCorporateOnlySections = isCorporateInfoSection();
    return (
      <>
        <footer className="Footer align-center" id="kontakt">
          <div className="grid--4-1 vgap-60 align-center">
            <div>
              <div className="w100 flex justify-center">
                <a href="/">
                  <img
                    className="Footer__img"
                    src={BluHolding}
                    alt="Blu Holding"
                  />
                </a>
              </div>
              <div className="Footer__social">
                <a
                  href="https://pl.linkedin.com/in/krzysztof-b%C5%82aszkiewicz"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("socialLinkedinKrzysztof")}
                >
                  <Linkedin />
                  <span>{t("socialLabelKrzysztof")}</span>
                </a>
                <a
                  href="https://pl.linkedin.com/company/bluholding-psa"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("socialLinkedinCompany")}
                >
                  <Linkedin />
                  <span>{t("socialLabelCompany")}</span>
                </a>
                <a
                  href="https://www.facebook.com/p/Blu-Holding-100089940169999/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("socialFacebookCompany")}
                >
                  <Facebook />
                  <span>{t("socialLabelCompany")}</span>
                </a>
              </div>
            </div>
            <div id="contact">
              <p className="Footer__text-with-icon">
                <img className="Footer__img" src={Mail} alt="Mail" />{" "}
                <a href="mailto:kontakt@bluholding.pl">kontakt@bluholding.pl</a>
              </p>
              <p className="Footer__text-with-icon">
                <img className="Footer__img" src={Phone} alt="Phone" />
                <a href="tel:+48525222249">
                  (+48) 52 522 22 49&nbsp;&nbsp;&nbsp;&nbsp;
                </a>
              </p>
              <a href="https://goo.gl/maps/XaKqFyvxeWt1SF666">
                <p>ul. Kijowska 44, 85-703 Bydgoszcz</p>
              </a>
              <hr className="Footer__divider" />
              <p className="Footer__branch-label">Oddział Warszawa</p>
              <a href="https://maps.google.com/?q=VARSO+2,+ul.+Chmielna+73,+00-802+Warszawa">
                <p>VARSO 2, ul. Chmielna 73<br />00-802 Warszawa</p>
              </a>
              <p className="Footer__text-with-icon">
                <img className="Footer__img" src={Phone} alt="Phone" />
                <a href="tel:+48690636527">690 636 527</a>
              </p>
            </div>
            <div className="flex justify-center flex-direction-column align-center">
              <img className="Footer__baner" src={Iot} alt="Blu Game Show" />
              <img
                className="Footer__img"
                src={Klaster}
                alt="Bydgoski Klaster Informatyczny"
              />
            </div>
            {this.#mainPageCallback ? (
              <div>
                <div>
                  <a
                    onClick={() => this.#mainPageCallback("#opis-projektu")}

                  >
                    {t("projectDesc")}
                  </a>
                </div>
                {showCorporateOnlySections && (
                  <div>
                    <a
                      onClick={() => this.#mainPageCallback("#faq")}

                    >
                      {t("discuss")}
                    </a>
                  </div>
                )}
                <div>
                  <a
                    onClick={() => this.#mainPageCallback("#dokumenty")}

                  >
                    {t("documents")}
                  </a>
                </div>
                {showCorporateOnlySections && (
                  <div>
                    <a
                      onClick={() => this.#mainPageCallback("#czynniki-ryzyka")}

                    >
                      {t("risks")}
                    </a>
                  </div>
                )}
                <div>
                  <a
                    onClick={() => this.#mainPageCallback("#nasze-inwestycje")}

                  >
                    {t("ourInvestments")}
                  </a>
                </div>
                <div>
                  <a href="https://e-pulpit24.pl/pl/nis2" target="_blank">{t("footer.nis2Cybersecurity")}</a>
                </div>
                <div>
                  <a href="https://360totalsecurity.pl/" target="_blank">{t("footer.cybersecurityInLogistics")}</a>
                </div>
              </div>
            ) : (
              <div>
                <div>
                  <a href="/#opis-projektu">{t("projectDesc")}</a>
                </div>
                {showCorporateOnlySections && (
                  <div>
                    <a href="/#faq">{t("discuss")}</a>
                  </div>
                )}
                <div>
                  <a href="/#dokumenty">{t("documents")}</a>
                </div>
                {showCorporateOnlySections && (
                  <div>
                    <a href="/#czynniki-ryzyka">{t("risks")}</a>
                  </div>
                )}
                <div>
                  <a href="/#nasze-inwestycje">{t("ourInvestments")}</a>
                </div>
                <div>
                  <a href="https://e-pulpit24.pl/pl/nis2" target="_blank">{t("footer.nis2Cybersecurity")}</a>
                </div>
                <div>
                  <a href="https://360totalsecurity.pl/" target="_blank">{t("footer.cybersecurityInLogistics")}</a>
                </div>
              </div>
            )}
          </div>
          {showCorporateOnlySections && (
            <div className="Footer__disclaimer">
              <p>{t("legalDisclaimer")}</p>
            </div>
          )}
        </footer>

        <a
          className="mobileContact"
          href="/#kontakt-formularz"
          onClick={() =>
            window.location.href.split("/")[3] === "#kontakt-formularz" ||
              window.location.href.split("/")[3] === ""
              ? this.#scrollContactSection(true)
              : (window.location.href = "/#kontakt-formularz")
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-envelope-fill"
            viewBox="0 0 16 16"
          >
            <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
          </svg>
        </a>
        <a
          className="mobileContact-2"
          href="tel:+48525222249"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
          </svg>
        </a>
      </>
    );
  }
}

export default withTranslation()(Footer);
